import React from 'react';
import { TvmTopicEntry } from '@src/lib/graphql/generated';

interface TvmTopicEntryPageProps {
  data: TvmTopicEntry;
}

export const TvmTopicEntryPage = ({ data }: TvmTopicEntryPageProps) => {
  return <div>{data.title}</div>;
};
